module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "box-preview-toolbar-button",
    class: _vm.activeButton(_vm.device),
    on: {
      "click": function($event) {
        return _vm.updateDevice(_vm.device);
      }
    }
  }, [_c('i', {
    class: 'kp-panel-' + _vm.icons[_vm.device]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.device))])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-76e19f8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/devicebuttons/DeviceButton.vue
 ** module id = 865
 ** module chunks = 1
 **/